import { concat } from '@ember/helper';
import { htmlSafe } from '@ember/template';
import or from 'ember-truth-helpers/helpers/or';
import BvAvatar from 'volta/components/bv-avatar';
import BvInline from 'volta/components/bv-inline';
import CodeDesc from 'volta/components/code-desc';

import type { TOC } from '@ember/component/template-only';
import type SearchEntry from 'volta/models/search-entry';
import type { PayloadUser } from 'volta/models/search-entry';

interface BvAppSearchEntryUserSignature {
  Args: {
    entry: SearchEntry<PayloadUser>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntryUserComponent: TOC<BvAppSearchEntryUserSignature> = <template>
  <BvInline @blockAlign='center' @gap='2' @wrap={{false}} class='u-overflow-hidden' ...attributes>
    <BvAvatar
      @size='sm'
      @firstName={{@entry.payload.firstName}}
      @lastName={{@entry.payload.lastName}}
      @login={{@entry.payload.login}}
    />
    <CodeDesc
      @code={{htmlSafe @entry.payload.login}}
      @desc={{concat
        (htmlSafe (or @entry.payload.firstName ''))
        ' '
        (htmlSafe (or @entry.payload.lastName ''))
      }}
      @fontVariant='body-sm'
      class='u-flex-1 u-ellipsis'
    />
  </BvInline>
</template>;

export default BvAppSearchEntryUserComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::User': typeof BvAppSearchEntryUserComponent;
    'bv-app-search/entry/user': typeof BvAppSearchEntryUserComponent;
  }
}
